import { attr } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const User = ApplicationRecord.extend({
  static: {
    jsonapiType: 'users',
  },
  attrs: {
    email: attr(),
    firstName: attr(),
    lastName: attr(),
    schoolId: attr(),
  },
})

export default User
